
import { storyList, indexData, stationData} from './story_data';
import { appUrl } from './constant';
import './ga/index'
import './common'

new WOW().init();

// Ticket Effect
let movieTicket = document.querySelector('.movie-ticket');
let ticketTimeout;

let effectLogic = (e) => {
    e.preventDefault();
    let pos = [e.offsetX,e.offsetY];
    if ( e.type === "touchmove" ) {
        pos = [ e.touches[0].clientX, e.touches[0].clientY ];
    }
    // math for mouse position
    let l = pos[0];
    let t = pos[1];
    let h = movieTicket.offsetHeight;
    let w = movieTicket.offsetWidth;
    let px = Math.abs(Math.floor(100 / w * l)-100);
    let py = Math.abs(Math.floor(100 / h * t)-100);
    let pa = (50-px)+(50-py);

    let lp = (50+(px - 50)/1.5);
    let tp = (50+(py - 50)/1.5);
    let ty = ((tp - 50)/2) * -1;
    let tx = ((lp - 50)/1.5) * .5;

    let tf = `rotateZ(-3deg) rotateX(${ty}deg) rotateY(${tx}deg)`

    movieTicket.style.transition = '.3s'
    movieTicket.style.transform = tf

    if ( e.type === "touchmove" ) {
        return false;
    }
    clearTimeout(ticketTimeout);
}
let effectLogicEnd = (e) => {
    e.preventDefault();
    ticketTimeout = setTimeout(function() {
        movieTicket.removeAttribute("style");
    }, 1000);
}
movieTicket.addEventListener('mousemove', effectLogic)
movieTicket.addEventListener('mouseout', effectLogicEnd)

// Teared
window.addEventListener('scroll', () => {
    if(window.scrollY > 80){
        movieTicket.classList.add('teared');
    }
})


// Kv Scale
let header = document.querySelector('#header')
let headerStyle = header.currentStyle || window.getComputedStyle(header);
let kvSun = document.querySelector('.kv-sun')
let kvContent = document.querySelector('.kv-content')

let spaceLeftSpace = header.offsetHeight - (kvSun.offsetHeight/3)*2 - parseInt(headerStyle.paddingTop)
let scaleAmount = spaceLeftSpace / kvContent.offsetHeight

if(window.innerHeight > 768){
    // center kvContent
    header.style.paddingBottom = (kvSun.offsetHeight/3)*2 + 'px'
}else{
    // scale kvContent & prevent overlapping 
    kvContent.style.transform = kvContent.offsetHeight > spaceLeftSpace ? `scale(${scaleAmount*1.05})` : `scale(1)`
    if(spaceLeftSpace < 300){
        kvContent.style.transform = kvContent.offsetHeight > spaceLeftSpace ? `scale(${scaleAmount*1.25})` : `scale(1)`
    }
}

checkInApp()

// Story Slider
generateStorySlide()
let storySwiper = new Swiper(".story-slider", {
    normalizeSlideIndex: 1,
    autoplay: {
        delay: 5000,
    },
    breakpoints: {
        1200: {
            slidesPerView: 3,
            spaceBetween: 36
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 24
        }
    },
    slidesPerView: 1.5,
    spaceBetween: 12,
    speed: 1500,
    centeredSlides: true,
    grabCursor: true,
    rewind: true,
    pagination: {
        el: ".story-swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: '.story-swiper-right',
        prevEl: '.story-swiper-left',
    },
});
storySwiper.slideTo(3,1500,false)
storySwiper.on('slideChange', function (swiper) {

    let activeIndex = swiper.activeIndex;
    let target = document.querySelectorAll('.story-card')[activeIndex]

    if(target){
        gtag('event', target.getAttribute('data-view_ga'));
    }
});

window.addEventListener('scroll', () => {
    if(window.scrollY > document.querySelector('#story').offsetTop){
        storySwiper.autoplay.start()
    }
})

// Timetable Slider
let timetableSwiper = new Swiper(".timetable-slider", {
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1500,
    allowTouchMove: false,
    rewind: true,
    // pagination: {
    //     el: ".timetable-swiper-pagination",
    //     clickable: true,
    //     renderBullet: function (index, className) {
    //         return '<span class="' + className + '">' + "<span></span>" + "</span>";
    //     },
    // }
});
// timetableSwiper.on('slideChange', function (swiper) {
//     checkTimetableReaded()
// });
// setInterval(() => {
//     timetableSwiper.slideNext()
// }, 3000)

// Station Slider
generateStationSlide()
let stationSwiper = new Swiper(".station-slider", {
    autoplay: {
        delay: 5000,
    },
    breakpoints: {
        1200: {
            slidesPerView: 3,
            spaceBetween: 36
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 24
        }
    },
    slidesPerView: 1,
    spaceBetween: 12,
    speed: 1500,
    centeredSlides: true,
    grabCursor: true,
    rewind: true,
    pagination: {
        el: ".station-swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: '.station-swiper-right',
        prevEl: '.station-swiper-left',
    },
});
stationSwiper.slideTo(1,1500,false)

stationSwiper.on('slideChange', function (swiper) {

    let activeIndex = swiper.activeIndex;
    let target = document.querySelectorAll('.station-card')[activeIndex]
    if(target){
        gtag('event', target.getAttribute('data-view_ga'));
    }

});
window.addEventListener('scroll', () => {
    if(window.scrollY > document.querySelector('#station').offsetTop){
        stationSwiper.autoplay.start()
    }
})

updateStoryLink()

setTimeout(() => {
    updateStoryLink()
}, 1000)

clickDebounce()

// Genetate Story Slide
function generateStorySlide() {
    let storySlideContainer = document.querySelector('.story-slider').querySelector('.swiper-wrapper')
    indexData.forEach((item, index) => {

        let dateArray = item.opening_date.split(',').map(function(item) {
            return parseInt(item, 10);
        });

        let storyCardLink = new Date() >= new Date(dateArray[0], dateArray[1], dateArray[2]) ? `<a href="${appUrl+indexData[index].story}/cover" class="card-link click-once"></a>` : '<a class="card-link" data-toggle="modal" data-target="#storyModal"></a>'
        let storyLabelText = new Date() >= new Date(dateArray[0], dateArray[1], dateArray[2]) ? `<h6 class="font-weight-normal">${indexData[index].label_opened}</h6>` : `<h6 class="font-weight-normal">${indexData[index].label}</h6>`
        let view_ga       = new Date() >= new Date(dateArray[0], dateArray[1], dateArray[2]) ? 'view_landing_homepage_story_'+indexData[index].story : 'view_landing_homepage_story_'+indexData[index].story+'_coming_soon'
        let click_ga      = 'click_landing_homepage_story_'+indexData[index].story
        let click_more_ga = 'click_landing_homepage_story_'+indexData[index].story+'_coming_soon'

        let reads = document.querySelector('meta[name="reads"]').getAttribute('content');
        let readsArray = JSON.parse(reads);
        let isReadClass = '';
        if(readsArray.includes(indexData[index].id)){
            isReadClass = 'readed'
        }

        storySlideContainer.innerHTML += `
            <div class="swiper-slide text-center story-card ${isReadClass}" data-view_ga="${view_ga}" data-click_ga="${click_ga}" data-click_more_ga="${click_more_ga}">
                ${storyCardLink}
                <div class="card-cover">
                    <img src="${appUrl+indexData[index].cover}" alt="${indexData[index].name}"/>
                    <div class="cover-status">
                        <h6 class="font-weight-normal">已觀看</h6>
                    </div>
                    <div class="cover-label">
                        ${storyLabelText}
                    </div>
                </div>
                <div class="card-text">
                    <h6 class="font-weight-normal">${indexData[index].intro}</h6>
                </div>
            </div>
            `
    })
    let storyCard = document.querySelectorAll('.story-card')
    storyCard.forEach((card, index) => {
        card.addEventListener('click', () => {
            if(card.querySelector('.card-link').href !== ''){
                gtag('event', card.getAttribute('data-click_ga'));
                return
            }else{
                gtag('event', card.getAttribute('data-click_ga'));
                updateStoryModalContent(indexData[index].modal_info, card.getAttribute('data-click_more_ga'))
            }
        })
    })
}

// Dynamic Story Modal Content
function updateStoryModalContent(info, ga) {
    let modal = document.querySelector('#storyModal')
    modal.querySelector('.modal-film').innerHTML = ''
    modal.querySelector('.modal-film').innerHTML = `
        <img class="film-holes holes-top" src="${appUrl}ben/npm/images/index/film-holes.svg">
        <h5 class="film-label">放映故事</h5>
        <p class="mt-2">${info.name}</p>
        <h5 class="film-label mt-3">放映地點</h5>
        <p class="mt-2">${info.location}</p>
        <h5 class="film-label mt-3">放映時間</h5>
        <p class="mt-2">${info.time}</p>
        <hr class="w-100 my-3" />
        <h6>${info.guide}</h6>
        <img class="film-holes holes-bottom" src="${appUrl}ben/npm/images/index/film-holes.svg">
    `
    modal.querySelector('.btn-ticket').setAttribute('data-ga', ga)
}

// Check Timetable Readed
function checkTimetableReaded() {
    let allTimetablePagination = document.querySelector('.timetable-swiper-pagination').querySelectorAll('.swiper-pagination-bullet')
    for(let item in allTimetablePagination) {
        if(allTimetablePagination[0].classList.contains('swiper-pagination-bullet-active')){
            allTimetablePagination.forEach((item) => {
                item.classList.remove('swiper-pagination-bullet-readed')
            })
        };
        // document.querySelector('.swiper-pagination-bullet-active').querySelector('span').style.animationDuration = 0 + 's'
        allTimetablePagination[item].classList.remove('swiper-pagination-bullet-readed')
        if(allTimetablePagination[item].classList.contains('swiper-pagination-bullet-active')) break;
        allTimetablePagination[item].classList.add('swiper-pagination-bullet-readed')
    }
}

// Generate Station Slide
function generateStationSlide() {
    let stationSlideContainer = document.querySelector('.station-slider').querySelector('.swiper-wrapper')

    stationData.forEach((item, index) => {

        stationSlideContainer.innerHTML += `
            <div class="swiper-slide text-center station-card" data-view_ga="${item.view_ga}">
                <div class="card-cover">
                    <div class="cover-label">
                        <div class="label-body">
                            <h4>${item.label}</h4>
                            <h5 class="font-weight-normal">故事名：${item.name}</h5>
                        </div>
                    </div>
                    <div class="cover-group">
                        <img class="default" src="${appUrl+item.image[0]}" alt="${item.name}"/>
                        <img class="active" src="${appUrl+item.image[1]}" alt="${item.name}"/>
                    </div>
                </div>
                <div class="card-btns">
                    <div class="btn btn-ticket btn-ticket-1 btn-choice rd-trigger-ga" data-ga="${item.click_left_ga}" data-toggle="modal" data-target="#stationModal"><span>${item.choices[0]}</span></div>
                    <div class="btn btn-ticket btn-ticket-1 btn-choice rd-trigger-ga" data-ga="${item.click_right_ga}" data-toggle="modal" data-target="#stationModal"><span>${item.choices[1]}</span></div>
                </div>
            </div>
            `
    })
    let stationCard = document.querySelectorAll('.station-card')
    stationCard.forEach((card, index) => {
        let cardBtns = card.querySelectorAll('.btn-choice')
        cardBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                updateStationModalContent(stationData[index].modal_info)
            })
        })
        let modalImg = appUrl + stationData[index].modal_info.image
        preloadImages(modalImg)
    })
}

// Dynamic Station Modal Content
function updateStationModalContent(info) {
    let modal = document.querySelector('#stationModal')
    modal.querySelector('.modal-image').querySelector('img').setAttribute('src', `${appUrl}ben/npm/images/station/guide-holder.png`)
    modal.querySelector('.modal-film').innerHTML = ''
    
    modal.querySelector('.modal-image').querySelector('img').setAttribute('src', appUrl+info.image)
    modal.querySelector('.modal-film').innerHTML = `
        <h6 class="film-label no-limit">${info.question}</h6>
        <h6 class="mt-3">${info.guide}</h6>
        <img class="film-holes holes-bottom" src="${appUrl}ben/npm/images/index/film-holes.svg">
    `
}

// Update Story Link
function updateStoryLink() {
    let allStoryCard = document.querySelectorAll('.story-card')
    let memberId = new URLSearchParams(window.location.search).get('memberId')
    let memberIdQueryString = memberId ? 'memberId=' + memberId : ''
    if(memberId){
        allStoryCard.forEach((card, index) => {
            if(card.querySelector('.card-link').href !== ''){
                card.querySelector('.card-link').setAttribute('href', `${appUrl+indexData[index].story}/cover?${memberIdQueryString}`)
            }
        })
    }

}